/** Texte der gemeinsamen Assistentenseite; Produkte übernehmen sie in ihre Wörterbücher. */
export const wizardDe = {
  "Wizard.steps": "Schritte",
  "Wizard.back": "zurück",
  "Wizard.next": "weiter",
  "Wizard.discardTitle": "Änderungen verwerfen?",
  "Wizard.discardContent": "Nicht gespeicherte Eingaben gehen verloren.",
  "Wizard.discard": "verwerfen",
  "Wizard.keepEditing": "weiter bearbeiten",
};

export const wizardEn: Record<keyof typeof wizardDe, string> = {
  "Wizard.steps": "Steps",
  "Wizard.back": "Back",
  "Wizard.next": "Next",
  "Wizard.discardTitle": "Discard changes?",
  "Wizard.discardContent": "Unsaved input will be lost.",
  "Wizard.discard": "Discard",
  "Wizard.keepEditing": "Keep editing",
};

export const wizardRu: Record<keyof typeof wizardDe, string> = {
  "Wizard.steps": "Шаги",
  "Wizard.back": "назад",
  "Wizard.next": "далее",
  "Wizard.discardTitle": "Отменить изменения?",
  "Wizard.discardContent": "Несохранённые данные будут потеряны.",
  "Wizard.discard": "отменить",
  "Wizard.keepEditing": "продолжить редактирование",
};

export const wizardUk: Record<keyof typeof wizardDe, string> = {
  "Wizard.steps": "Кроки",
  "Wizard.back": "назад",
  "Wizard.next": "далі",
  "Wizard.discardTitle": "Скасувати зміни?",
  "Wizard.discardContent": "Незбережені дані буде втрачено.",
  "Wizard.discard": "скасувати",
  "Wizard.keepEditing": "продовжити редагування",
};

export const wizardIt: Record<keyof typeof wizardDe, string> = {
  "Wizard.steps": "Passaggi",
  "Wizard.back": "indietro",
  "Wizard.next": "avanti",
  "Wizard.discardTitle": "Annullare le modifiche?",
  "Wizard.discardContent": "I dati non salvati andranno persi.",
  "Wizard.discard": "annulla",
  "Wizard.keepEditing": "continua a modificare",
};
